import React, { useState } from 'react'
import { getSettingsApi, newSettingApi, editSettingApi, deleteSettingApi } from '../api/settings'
import { useAuth } from './';
//Obtener Token


export function useSettings() {

const [loading, setLoading] = useState(true);
const [error, setError] = useState(false);
const [setting, setSetting] = useState([]);

const {auth} = useAuth();


const getSettings = async () =>{
    try {
        setLoading(true);
        const response = await getSettingsApi();
        setLoading(false);
        setSetting(response);
    } catch (error) {
        setLoading(false);
        console.error(error)
    }
}


const newSetting = async(data) =>{
  
  try {
    setLoading(true)
    await newSettingApi(data, auth.token);
    setLoading(false);
   
  } catch (error) {
    setLoading(false)
    setError(error)
  }
}


const editSetting = async(id, data) =>{
  try {
    setLoading(true);
    await editSettingApi(id, data, auth.token);
    setLoading(false);
  } catch (error) {
    setLoading(false);
    setError(error);
  }
}

const deleteSetting = async(id) =>{
    try {
      setLoading(true);
      await deleteSettingApi(id, auth.token);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  }


  return{
    loading,
    error,
    setting,
    getSettings,
    newSetting,
    editSetting,
    deleteSetting

  }




}
